import { useState } from "react";

function UseToast() {
  const [toastOpen, setToastOpen] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toastType, setToastType] = useState<string>("danger");
  const onToastClose = () => {
    setToastOpen(false);
    setToastMessage(null);
    setToastType("danger");
  };

  return {
    toastOpen,
    setToastOpen,
    toastMessage,
    setToastMessage,
    toastType,
    setToastType,
    onToastClose,
  };
}
export default UseToast;
